import React, { useEffect, useState } from "react";
import StaffLayout from "@/components/StaffLayout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function AdminAuditoria() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    api.get("/admin/audit-log?limit=200").then((r) => { setItems(r.data.items); setTotal(r.data.total); });
  }, []);

  return (
    <StaffLayout user={user} superadmin>
      <div>
        <p className="text-xs uppercase tracking-widest text-[#93C5FD] font-semibold">Auditoría</p>
        <h1 className="mt-2 text-3xl font-bold text-white font-display">Audit log · {total} eventos</h1>
        <div className="mt-6 overflow-x-auto border border-gray-800 rounded-xl">
          <table className="w-full text-sm" data-testid="audit-log-table">
            <thead className="bg-[#0F172A] text-xs uppercase tracking-widest text-gray-400">
              <tr>
                <th className="text-left px-3 py-2">Acción</th>
                <th className="text-left px-3 py-2">Recurso</th>
                <th className="text-left px-3 py-2">Actor</th>
                <th className="text-left px-3 py-2">Fecha</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} className="border-t border-gray-800">
                  <td className="px-3 py-2 font-mono text-[#93C5FD] text-xs">{a.action}</td>
                  <td className="px-3 py-2 text-gray-300">{a.resource_type} <span className="text-gray-500 font-mono text-xs">{a.resource_id}</span></td>
                  <td className="px-3 py-2 text-gray-400 font-mono text-xs">{a.actor_user_id}</td>
                  <td className="px-3 py-2 text-gray-500 font-mono text-xs">{new Date(a.created_at).toLocaleString("es-MX")}</td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={4} className="px-3 py-8 text-center text-gray-500">Sin eventos.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </StaffLayout>
  );
}
